import React, { useContext } from "react"
import "./Styles/list.scss"
import classNames from "classnames"

import Summary from "../Common/Place/Takeaway/Summary"
import Loader from "../Common/Loader"
import { PCViewContext } from "../Common/PCViewContext"

const TakeawayList = (props) => {
  const isPC = useContext(PCViewContext)
  const places = JSON.parse(props.takeaways)
  return (
    <React.Fragment>
      <h2 className={classNames("p-top-section__header", isPC ? "pc" : "sp")}>
        最新のテイクアウト情報
      </h2>
      <div className="p-top-section__takeaway">
        {places.map((place) => (
          <React.Fragment key={place.id}>
            <div className="p-top-section__row">
              <Summary {...props} place={place} />
            </div>
          </React.Fragment>
        ))}
      </div>
      <a
        href="#"
        className={classNames("p-top-section__more-button", isPC ? "pc" : "sp")}
        onClick={(e) => {
          e.preventDefault()
          props.onClick()
        }}
      >
        <div>
          <Loader
            show={props.showLoader}
            color="green"
            small={true}
            style={{ margin: "0.75rem auto" }}
          />
          {!props.showLoader && <span>近くのテイクアウトを見る</span>}
        </div>
      </a>
    </React.Fragment>
  )
}

export default TakeawayList
